<script lang="ts">
  import { onMount } from 'svelte';
  import Modal from './ui/Modal.svelte';
  import Button from './ui/Button.svelte';

  // One-time welcome modal — explains the game concept to new
  // visitors so the daily mode lands on `/` doesn't read as "what
  // am I supposed to do here?" Shown once per browser; dismissal is
  // tracked in localStorage under a versioned key.
  //
  // To DISABLE: comment out / remove the <WelcomeNotice /> mount in
  // App.svelte. One-line revert; nothing else to clean up.
  //
  // To REPLACE with a fresh popup later: bump NOTICE_VERSION below.
  // Old dismissals don't carry over because the storage key changes —
  // every browser sees the new copy regardless of their prior
  // dismissal state.

  const NOTICE_VERSION = 'v2';
  const STORAGE_KEY = `atlasguess.welcome.${NOTICE_VERSION}`;

  let open = $state(false);

  onMount(() => {
    if (typeof window === 'undefined') return;
    try {
      const dismissed = window.localStorage.getItem(STORAGE_KEY);
      if (!dismissed) {
        // Tiny delay so the modal doesn't fight the SPA's first paint.
        setTimeout(() => {
          open = true;
        }, 600);
      }
    } catch {
      // localStorage blocked / private mode — show the modal anyway,
      // we just won't be able to suppress it on the next visit.
      open = true;
    }
  });

  function dismiss(): void {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      // Best-effort; same fallback behavior as above.
    }
    open = false;
  }
</script>

<Modal bind:open title="Welcome to AtlasGuess!!" size="md" onClose={dismiss}>
  <div class="welcome-notice">
    <p>
      We&rsquo;ll give you 5 random cities around the globe, and your
      mission is simple: click as close as you can to each one. You&rsquo;ll
      get points out of 100 for each guess &mdash; try to get the highest
      average score every day!
    </p>

    <p>
      There are also practice modes to learn more about the cities and
      countries of the world.
    </p>

    <p class="welcome-notice__signoff">Have fun!</p>
  </div>

  {#snippet footer()}
    <Button variant="primary" onclick={dismiss}>Got it</Button>
  {/snippet}
</Modal>
